import { InputGroup, Input, InputLeftElement } from "@chakra-ui/react";
import { FaSearch } from "react-icons/fa";

const SearchBar = ({ search, setSearch }) => (
  <InputGroup maxW="300px">
    <InputLeftElement pointerEvents="none" children={<FaSearch />} />
    <Input
      size="sm"
      placeholder="Search by name, phone, bill no..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </InputGroup>
);

export default SearchBar;
